import React from 'react';

interface PlayPauseButtonProps {
    isPlaying: boolean;
    onToggle: () => void;
    className?: string;
}

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
    isPlaying,
    onToggle,
    className = 'play-pause-button',
}) => {
    return (
        <button
            onClick={onToggle}
            className={className}
            style={{
                backgroundColor: isPlaying ? '#dc3545' : '#28a745',
            }}
        >
            {isPlaying ? '⏸️ Pause' : '▶️ Play'}
        </button>
    );
};

export default PlayPauseButton;